// A slot the app-shell top bar renders into: pages set breadcrumbs + right-
// aligned actions for the header. Management pages leave it empty (the shell
// falls back to the page title); the vault view fills it with a path breadcrumb
// and the Members/History actions.

import {
  createContext,
  useContext,
  useLayoutEffect,
  type DependencyList,
  type ReactNode,
} from "react";

export interface HeaderSlot {
  crumbs?: ReactNode;
  actions?: ReactNode;
}

export const HeaderSlotCtx = createContext<(slot: HeaderSlot) => void>(() => {});

/**
 * Set the shell header's breadcrumbs + actions for the current page. `crumbs`
 * and `actions` are freshly-built nodes each render, so the update is applied
 * only when `deps` change; the slot is cleared on unmount. useLayoutEffect so
 * the header updates before paint (no title→breadcrumb flash).
 */
export function useShellHeader(crumbs: ReactNode, actions: ReactNode, deps: DependencyList): void {
  const setSlot = useContext(HeaderSlotCtx);
  useLayoutEffect(() => {
    setSlot({ crumbs, actions });
    return () => setSlot({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSlot, ...deps]);
}
